export var TaxType;
(function (TaxType) {
    TaxType[TaxType["INCLUDED"] = 0] = "INCLUDED";
    TaxType[TaxType["ADDED"] = 1] = "ADDED";
    TaxType[TaxType["ADDED_AT_CHECKOUT"] = 2] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
